module.exports = __webpack_public_path__ + "img/4.d5c6fe82.png";